<template>
  <div class="mobile-achieve">
    <div class="achieve-header">研究成果</div>
    <swiper :options="swiperOption" ref="mySwiper" class="my-swiper">
      <!-- 渲染内容 -->
      <swiper-slide
        class="swiper-item"
        v-for="item in harvestList" :key="item.id"
        :style="{
            'background-image': `url(${item.img})`
          }">
          <div class="item-list">
            <p class="item-title">{{item.title}}</p>
            <div class="item-btn" @click="handleRoute(item)">点击下载</div>
          </div>
      </swiper-slide>
      <!-- 轮播小圆点 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import { harvestList } from './data'

export default {
  name: '',
  components: {
    swiper,
    swiperSlide
  },
  props: {
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      harvestList
    }
  },
  computed: {
    // swiper () {
    //   // return this.$refs.mySwiper.swiper
    // }
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    handleRoute (item) {
      window.location.href = item.link
    }
  }
}
</script>
<style lang='scss' scoped>
@import '~swiper/dist/css/swiper.css';
.mobile-achieve {
  box-sizing: border-box;
  width: 100%;
  padding-top: 50px;
  padding-bottom: 32px;
  background: #F0F4F8;
  text-align: center;
  .achieve-header {
    font-size: 20px;
    font-weight: 500;
    color: #404040;
    line-height: 28px;
  }
  .my-swiper {
    margin-top: 24px;
    padding: 0 20px 38px;
    ::v-deep .swiper-pagination {
      .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        background: #B9BDC2;
      }
      .swiper-pagination-bullet-active {
        width: 6px;
        height: 6px;
        background: #B9BDC2;
      }
    }
    & .swiper-item {
      width: 295px;
      height: 155px;
      background-position: center;
      background-size: 100% 100%;
      & .item-list {
        margin: 33px 32px 24px 128px;

        & .item-title {
          font-size: 15px;
          font-weight: 500;
          color: #404040;
          line-height: 21px;
          text-align: left;
        }
        & .item-btn {
          width: 120px;
          height: 32px;
          line-height: 32px;
          margin-top: 23px;
          background: linear-gradient(90deg, #2E7DFF 0%, #71A7FF 100%);
          border-radius: 16px;
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;

        }
      }
    }
  }
}
</style>
